// 判断权限code在不在数组里
function checkCodeInArr(code, arr) {
  arr = arr || sessionStorage.getItem("permission_btns") || [];
  if (!code) {
    return true;
  }
  arr = typeof arr == "string" ? JSON.parse(arr) : arr;
  let flag = false;
  for (let k = 0; k < arr.length; k++) {
    if (arr[k].buttonCode == code) {
      flag = true;
      break;
    }
  }

  return flag;
}

function merge(colArr, list) {
  var allProps = [];
  colArr.forEach((props, index) => {
    allProps.push(props);
    list = getLevel(props, allProps, list);
  });
  return list;
}

//组装层
function getLevel(props, allProps, list) {
  // rowkey为需要合并的字段在列表数据中不同值的合集
  var rowKey = {};
  for (var item of list) {
    // 根据需要合并的字段和每条数据，查找出该条数据中该字段对应的值
    let propInfo = getPropStr(allProps, item);

    if (rowKey[propInfo.key]) {
      // 将需要合并字段相等的数据push到一个数组中，用于后面控制跨几行
      rowKey[propInfo.key].children.push(item);
    } else {
      // 如果当前这个字段的值在rowKey当中不存在就新建一个
      let obj = propInfo;
      obj.children = [item];
      rowKey[propInfo.key] = obj;
    }
  }
  let info = [];
  for (var key in rowKey) {
    rowKey[key].children.forEach((item, index) => {
      // 循环每个值下面的children，给每个值的第一条数据加合并单元格，其余的隐藏
      if (index == 0) {
        item = Object.assign(
          item,
          getMergeInfo(props, rowKey[key].children.length)
        );
      } else {
        item = Object.assign(item, getMergeInfo(props, 0));
      }
      info.push(item);
    });
  }
  // 将处理好的列表数据返回
  return info;
}

//获取合并信息
function getMergeInfo(props, num) {
  let obj = {};
  obj[props + "_merge"] = {
    rowspan: num,
    colspan: 1
  };
  return obj;
}
// 把属性的值拼接在一起,并和属性的值一起返回。
/**
 *
 * @param {需要进行合并的label数组} props
 * @param {列表里的每一条数据} info
 * @returns {key: '出勤', classification: '出勤'}
 */
function getPropStr(props, info) {
  let obj = {};
  let propStr = props.map(item => {
    obj[item] = info[item];
    return info[item];
  });
  obj.key = propStr.toString();
  return obj;
}

function routeClose(str, setState, timeout) {
  if (!str) return;
  var routerBase = "/" + str;
  let msg = {
    title: this.$route.meta.title,
    url: `${routerBase}/#${this.$route.fullPath}`,
    meta: this.$route.meta,
    timeout: timeout || 0
  };
  setTimeout(() => {
    setState({
      ignore: "closeAddTab",
      msg
    });
  });
}
function autoSaving() {
  return 5000;
}

let dictionary = {
  val: null,
  getDict(topicKey) {
    if (this.val && topicKey) {
      return this.val[topicKey]
    } else if (topicKey) {
      return []
    } else {
      return this.val
    }
  },
  setDict(_val) {
    let result = {}
    if (this.val) {
      result = {...this.val}
    }
    if (_val && _val.length>0) {
      _val.map((item) => {
        let dictList = []
        if (item.dictList && item.dictList.length>0) {
          item.dictList.map(dictItem => {
            dictList.push({
              dataName: dictItem.dictName,
              dataValue: dictItem.dictValue
            })
          })
        }
        result[item.topic] = dictList;
      });
    }
    this.val = result
  }
}

/**
 * 二次确认框
 * @param {Object}
 * params.content 内容
 * params.title 标题
 * params.okFun 点确定的回调
 * params.cancelFun 点取消的回调
 */
function showConfirmMessage(params) {
  let content = params ? params.content : "";
  let title = params ? params.title : "";
  this.$confirm(content, title, {
    type: "warning",
    center: true,
    showClose: false,
    showCancelButton: true, // 是否显示取消按钮
    showConfirmButton: true, // 是否显示确认按钮
    cancelButtonText: "取消", // 取消按钮名字
    confirmButtonText: "确认", // 确定按钮名字
    customClass: "changsha_confirm" //  类名必传支持三种样式
  })
    .then(() => {
      if (params && params.okFun) {
        params.okFun();
      }
    })
    .catch(() => {
      if (params && params.cancelFun) {
        params.cancelFun();
      }
    });
}

function downloadFile(request, url, fileName = "", params = {}, method = "post") {
  request({
    url: url,
    method: method,
    responseType: `blob`, //一定要写
    params: method == "get" ? params : {},
    data: params,
  }).then((res) => {
    let objectUrl = URL.createObjectURL(res.data);
    let link = document.createElement("a");
    link.href = objectUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    // 下载完成移除元素
    document.body.removeChild(link);
    // 释放blob对象
    window.URL.revokeObjectURL(objectUrl);
  });
}

export default {
  checkCodeInArr,
  merge,
  routeClose,
  showConfirmMessage,
  autoSaving,
  dictionary,
  downloadFile
};



// WEBPACK FOOTER //
// ./packages/SrUtils/index.js